import React from 'react';
import { MAIN_RESOURCES } from '../utils/constants';
const colors = [{
  bg: 'bg-blue-50',
  border: 'border-blue-200',
  text: 'text-blue-900',
  circle: 'bg-blue-900'
}, {
  bg: 'bg-green-50',
  border: 'border-green-200',
  text: 'text-green-900',
  circle: 'bg-green-900'
}, {
  bg: 'bg-orange-50',
  border: 'border-orange-200',
  text: 'text-orange-900',
  circle: 'bg-orange-900'
}, {
  bg: 'bg-purple-50',
  border: 'border-purple-200',
  text: 'text-purple-900',
  circle: 'bg-purple-900'
}, {
  bg: 'bg-red-50',
  border: 'border-red-200',
  text: 'text-red-900',
  circle: 'bg-red-900'
}];
export function WhatIsIncluded() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-333">
      <div className="max-w-7xl mx-auto" data-id="element-334">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-335">
          Cosa include il Mega-Pack
        </h2>

        <div className="space-y-6" data-id="element-336">
          {MAIN_RESOURCES.map((resource, index) => {
          const color = colors[index];
          return <div key={index} className={`${color.bg} border ${color.border} rounded-lg p-6 flex gap-4`} data-id="element-337">
                <div className={`${color.circle} text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0 bg-opacity-60`} data-id="element-338">
                  {index + 1}
                </div>
                <div data-id="element-339">
                  <h3 className={`text-xl font-bold ${color.text} mb-2`} data-id="element-340">
                    {resource.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-341">{resource.description}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}